import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../../menus/service/menu.store';
import { ReservationUtils } from 'app/event/utils/reservation-utils';
import { List } from 'immutable';
import { ReservationCompare } from 'app/event/models/reservation-compare';
import { PaymentStore } from '../../service/payment.store';

@Component({
  selector: 'pioneer-reservation-page',
  templateUrl: './reservation-page.component.html'
})
export class ReservationPageComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  hasFinalPayment: boolean;

  constructor(private eventStore: EventStore,
              private reservationCompareStore: ReservationCompareStore,
              private menuStore: MenuStore,
              private paymentStore: PaymentStore) {
  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(this.onyxEvent.name, this.onyxEvent.eventProperty.subscriber);
    }

    if (!this.onyxEvent.eventId) {
      this.hasFinalPayment = false;
    } else {
      this.paymentStore.getLatestFinalPayment().take(1).subscribe(lastFinalPayment => {
        let value = lastFinalPayment && lastFinalPayment.eventPaymentId;
        this.hasFinalPayment =  Boolean(value);
      });
    }
  }

  getSummarySelected(): Observable<boolean> {
    return this.reservationCompareStore.getShowReservationCompareSummary();
  }

  showDownloadDropdown(): Observable<boolean> {
    return this.getFilteredReservations().map((list) => {
      return list && list.size > 0;
    });
  }

  private getFilteredReservations(): Observable<List<ReservationCompare>> {
    return this.reservationCompareStore.getCurrentFilteredReservations()
      .map(reservationList => ReservationUtils.onlyReservationsFilter(reservationList));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-page/reservation-page.component.ts